<script>
  export let color = '';
  export let imgUrl = '';
  export let showPoweredBy = '';
  export let sbGreeting = null;
  export let sbSlogan = null;
  export let recentText = null;
  export let similarText = null;

  let recentProducts = [
    {
      name: 'Syltherine',
      price: '160',
      image: '/img/preview-product-1.png',
    },
    {
      name: 'Lolito',
      price: '240',
      image: '/img/preview-product-2.png',
    },
    {
      name: 'Black chair',
      price: '240',
      image: '/img/preview-product-3.png',
    },
  ];
  let similarProducts = [
    {
      name: 'Blue armchair',
      price: '360',
      image: '/img/preview-product-4.png',
    },
    {
      name: 'Lolito',
      price: '240',
      image: '/img/preview-product-2.png',
    },
    {
      name: 'Wooden chair',
      price: '240',
      image: '/img/preview-product-1.png',
    },
  ];
</script>

<section class="preview-wrapper">
  <div class="preview-header" style="--bg-preview-color:{color};">
    <img class="preview-logo" src={imgUrl} alt="" />

    <p class="preview-greeting">{sbGreeting ? sbGreeting : 'Hi'}</p>
    <p class="sb-slogan">{sbSlogan ? sbSlogan : 'I am your personal shopping assistant'}</p>
  </div>
  <div class="preview-body">
    <div class="preview-product-grid">
      <p class="sb-heading">{recentText ? recentText : 'Recently Viewed Items'}</p>
      <ul>
        {#each recentProducts as product}
          <li>
            <img src={product.image} alt="Example product." />
            <p class="example-product-name">{product.name}</p>
            <span class="example-product-price">€{product.price}</span>
          </li>
        {/each}
      </ul>
      <div class="preview-button">
        <p>See more products</p>
      </div>
    </div>
    <div class="preview-product-grid">
      <p class="sb-heading">{similarText ? similarText : 'Similar Products'}</p>
      <ul>
        {#each similarProducts as product}
          <li>
            <img src={product.image} alt="Example product." />
            <p class="example-product-name">{product.name}</p>
            <span class="example-product-price">€{product.price}</span>
          </li>
        {/each}
      </ul>
    </div>
  </div>
  <div class="preview-footer">
    <p class={showPoweredBy}>Powered by Shopbox</p>
  </div>
</section>

<style>.preview-wrapper{border-radius:8px;box-shadow:0 8px 12px hsla(23,72%,68%,.2),0 2px 8px rgba(0,0,0,.2);height:420px;left:100%;margin:0 0 0 1em;overflow:hidden;position:absolute;top:0;width:260px}.preview-body,.preview-footer,.preview-header{padding:.5em .5em 0}.preview-header{height:80px;position:relative}.preview-header:after{background-color:var(--bg-preview-color);content:"";height:100%;left:0;opacity:.3;position:absolute;top:0;width:100%}.preview-logo{display:block;height:24px;left:12px;margin-bottom:.6em;-o-object-fit:contain;object-fit:contain;-o-object-position:left;object-position:left;top:8px}.client-name{font-size:1.1rem;font-weight:400;margin-bottom:.6em}.client-name,.preview-greeting{color:#000}.example-product-name,.example-product-price,.preview-product-grid>p,.sb-slogan{color:var(--t-c-l);font-size:.75rem;font-weight:100}.example-product-name{color:var(--t-c)}.preview-body{height:70%}.preview-product-grid{border:1px solid #e0e0e0;border-radius:4px;height:auto;margin-bottom:.5em}ul{display:flex;justify-content:space-around;list-style:none;padding:0}li>img{border-radius:4px}.preview-product-grid>p{color:var(--t-c);margin:.5em}.preview-button{border-top:1px solid #e0e0e0;padding:.3em 0}.preview-button p{color:var(--t-c);font-size:.75rem}.preview-button,.preview-footer{background:#f2f2f2;text-align:center}.preview-footer{bottom:0;height:16px;padding-top:.2em;position:absolute;width:100%}.preview-footer p{color:var(--t-c-l);font-size:.6rem;font-weight:100;text-decoration:underline}.preview-footer p.true{display:none}@media (max-width:1200px){.preview-wrapper{display:none}}</style>
